import axios from 'axios';
import urls from '~/services/urls';

const apiClient = axios.create({
    baseURL: urls.apiBase,
    timeout: 5000,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
    xsrfHeaderName: "X-XSRF-TOKEN",
    withCredentials: true
});

export default apiClient;